'use strict';

var _ = require('lodash');
var RomSummaryThematicChartsController = function RomSummaryThematicChartsController($scope, dataService, dataPreparationService, dataRetrieverConstantsService) {
  $scope.chartType = 'opportunity-trend';
  $scope.initData = null;
  $scope.data = null;
  $scope.getData = function () {
    return dataService.getData(dataRetrieverConstantsService.ROM_SUMMARY_SCREEN, dataRetrieverConstantsService.ROM_SUMMARY_MODE, _.kebabCase($scope.chartTitle) + '-thematic-chart');
  };
  $scope.groupData = dataPreparationService.groupData($scope.grouping);
  $scope.loadData = function () {
    if (canChartRender()) {
      $scope.getData().then($scope.groupData).then(function (data) {
        if (!$scope.initData) {
          $scope.data = data;
          $scope.initData = data;
        } else {
          $scope.data = dataPreparationService.mergeData($scope.initData, data, $scope.filterType);
        }
      }).then($scope.prepareDataForChart).then($scope.renderChart);
    }
  };
  $scope.prepareDataForChart = function () {
    switch ($scope.chartView) {
      case 'OPPORTUNITY_TREND':
        return dataPreparationService.prepareForTrendOpportunity($scope.data);
      case 'MIN_ACT_MAX_REVENUE':
        return dataPreparationService.prepareForMinActMaxRevenue($scope.data);
      case 'DMND_PAX':
        return dataPreparationService.prepareForDemandAndPaxVsOptimal($scope.data);
      case 'AVG_FARE':
        return dataPreparationService.prepareForAvgFareVsOptimal($scope.data);
      case 'DMND_WEIGHT':
        return dataPreparationService.prepareForDemandWeightedOpenPercentVsOptimal($scope.data);
    }
  };
  $scope.$on('brush-filter:filterApplied', function (event, filter) {
    if (filter.filterType !== $scope.filterType) {
      $scope.data = undefined;
      $scope.buildChart();
    }
  });
  $scope.$on('search-criteria:searchChangeEvent', function () {
    $scope.initData = null;
  });
  $scope.$on(dataRetrieverConstantsService.ROM_SUMMARY_SCREEN + ':flowTypeChanged', function () {
    $scope.loadData();
  });
  function canChartRender() {
    var filters = dataService.getFilters(dataRetrieverConstantsService.ROM_SUMMARY_SCREEN, dataRetrieverConstantsService.ROM_SUMMARY_MODE);
    return !(filters === undefined || filters['filter-component'] === undefined);
  }
};
RomSummaryThematicChartsController.$inject = ['$scope', 'RomSummaryChartsDataService', 'RomSummaryChartsDataPreparationService', 'DataRetrieverConstantsService'];
module.exports = RomSummaryThematicChartsController;